<template>
  <div class="bg">
    <div class="appBox">
      <div class="app">
        <div
          v-for="(item, index) in appOptions"
          :key="index"
          @click="selectApp(index, item.appName)"
        >
          <router-link :to="item.path">
            <el-card shadow="always">
              <span>
                <i :class="item.icon" />
                {{ item.appName }}
              </span>
              <i class="el-icon-arrow-right" />
            </el-card>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { postDictCode } from "@/api/dict";
  export default {
    data() {
      return {
        appShow: Number,
        showApps: "show",
        appName: "应用",
        appOptions: [
          {
            appName: "项目信息",
            icon: "iconfont icon-xinxi",
            path: "/projectInfo",
          },
          {
            appName: "企业信息",
            icon: "iconfont icon-jianzhu1",
            path: "/enterpriseInfo",
          },
          {
            appName: "参建单位",
            icon: "iconfont icon-jianzhu1",
            path: "/unitInfo",
          },
          {
            appName: "班组登记",
            icon: "iconfont icon-renyuan1",
            path: "/teamInfo",
          },
          {
            appName: "人员名单",
            icon: "iconfont icon-untitled18",
            path: "/recruit",
          },
          {
            appName: "实名认证",
            icon: "iconfont icon-ID",
            path: `/certificationRecord/essentialInfo/${0}`,
          },
          {
            appName: "认证记录",
            icon: "iconfont icon-lishijilu",
            path: "/certificationRecord",
          },
          {
            appName: "在线考勤",
            icon: "iconfont icon-kaoqindaka",
            path: "/onlineAttendance",
          },
          {
            appName: "考勤记录",
            icon: "iconfont icon-jinrizhibanjinglishu",
            path: "/attendanceHistory",
          },
          {
            appName: "考勤设备",
            icon: "iconfont icon-lianhe5",
            path: "/equipment",
          },
          {
            appName: "下发记录",
            icon: "iconfont icon-lishi",
            path: "/issueHistory",
          },
        ],
      };
    },
    created() {
      this.$store.dispatch("submitToken");
      this.entryStatus();
    },
    mounted() {},
    methods: {
      selectApp(index, appName) {
        this.appName = appName;
        this.appShow = index;
        this.showApps = "false";
      },
      entryStatus() {
        postDictCode("entry_status").then((res) => {
          this.$store.commit("Dict", res.data);
        });
      },
    },
  };
</script>
<style lang="less" scoped>
  .bg {
    margin-bottom: 40px;
    min-height: 100vh;
    background-color: #f0f0f0;
    padding: 2px 0 10px 0;
    // padding-bottom: 30px;
  }
  .headerText {
    position: relative;
    .backIcon {
      position: fixed;
    }
    button {
      width: 100%;
      border: none;
      color: #fff;
      font-size: 16px;
      background-color: #1564c3;
    }
  }
  .appBox {
    width: 100%;
    height: 100%;
    // min-height: 100vh;
    background-color: #f0f0f0;
    .app {
      margin: 10px;
      div {
        margin-bottom: 10px;
        /deep/ .el-card__body {
          display: flex;
          justify-content: space-between;
          align-items: center;
          span {
            font-size: 16px;
          }
          i {
            white-space: nowrap;
            font-size: 22px;
            color: #1564c3;
            margin-right: 5px;
          }
        }
      }
    }
  }
</style>
